import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import React, { forwardRef, useCallback, useEffect, useRef, useState, useImperativeHandle } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import {
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import Progress from "./Progress";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useDropzone } from "react-dropzone";
import { useMemo } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { blue, blueGrey, grey } from "@mui/material/colors";
import MasterDialog from "./MasterDialog";
import dataSpacePlaning from "./dataSpacePlaning";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import jwtDecode from "jwt-decode";
import Notification from "./Notification";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
  timelineOppositeContentClasses,
} from "@mui/lab";
import SpacePlaningRequest from "./SpacePlaningRequest";
import { toast } from "react-toastify";

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;
const uploadMultipleFiles = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.uploadMultipleFiles}`;
const findTop20BySrNoUrl = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.findTop20BySrNo}`;
const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .or": {
      backgroundColor: grey[800],
      borderRadius: "100%",
      width: 30,
      height: 30,
      lineHeight: "30px",
      display: "inline-block",
    },
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#fff !important",
  backgroundColor: blue[500],
  padding: "12px 30px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",

  "&:hover": {
    backgroundColor: blue[700],
  },
  "&[disabled]": {
    opacity: 0.4,
    background: grey[700],

    "& .file": {
      cursor: "not-allowed",
    },
  },
  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));



const Download = (props) => {
  const { data } = props;
  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${data.data?.uploadWinnerFile}?path=${data.data?.uploadWinnerPath}`;

const loadFiles = async () => {
  const blob = await fetch(downloadPath, OAuthService.config()).then(resp => resp.blob());
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = data.data?.uploadWinnerFile
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(objUrl);
  document.body.removeChild(a);
};  

  return (
    <span>
        <Button variant="outlined" size="small" onClick={loadFiles} startIcon={<FuseSvgIcon>heroicons-outline:download</FuseSvgIcon>}>
          Download
        </Button>
    </span>
  );
}

export default function SpacePlaning(props) {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [openRequest, setOpenRequest] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const classes = useStyles(props);
  const [notificationContent, setNotificationContent] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [rowData, setRowData] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [selectedFiles, setFiles] = useState();
  const [productId, setProductId] = useState([]);
  const gridRef = useRef();
  const navigate = useNavigate();

  const uploadFiles = async () => {
    const payload = {
      //presentationFile: acceptedFiles[0],
      presentationFile: selectedFiles,
    };
    console.log(payload);
    const list = await OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&category=SHR&updatedBy=ramde`,
      payload
    );
    // http://localhost:9091/api/designStudio/uploadMultipleFiles?dsTaskId=5&displayMaster=1&category=SHR&updatedBy=arunpnair007%40gmail.com
  };
  const handleBack = () => {
    navigate("/design-studio/request-review/" + id);
  };
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [changes, setChanges] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const hiddenPdfFile = useRef(null);
  const hiddenPresentationFile = useRef(null);
  const [pdf, setPDF] = useState(null);
  const [presentation, setPresentation] = useState(null);


  const loadDate = async () => {
    try {
      const list = await OAuthService.getList(`${url}/${id}`);
      let data = list.data;
      const changesTracker = [];
      const ids = data?.spacePlans.map(spacePlan => spacePlan.srNo);
      const promises = ids.map(spacePlanId => new Promise((resolve, reject) => {
        OAuthService.getList(`http://localhost:9091/api/designStudio/spacePlanRevisions/search/findTop20BySrNo?srNo=${spacePlanId}&page=0&size=20`)
          .then(resp => resolve(resp?.data?._embedded.spacePlanRevisions))
      }))
      const d = await Promise.all(promises);
      d.map(e =>changesTracker.push(...e))
      setBtnDisable(data.spacePlans.length === 0 || !data.submissionDate || (!data.uploadPresentationFile && !data.uploadPRVFile))
      console.log(data)
      setCurrentStatus(data?.dsLifeCycle);
      setRowData(data?.spacePlans);
      setData(data);
      setPDF(!data?.uploadPRVFile ? null : {name: data?.uploadPRVFile})
      setPresentation(!data?.uploadPresentationFile ? null :{name: data?.uploadPresentationFile});
      setChanges(changesTracker);


    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  useEffect(() => {
    loadDate();
  }, []);


  const _cellStyle = params => {
    const { data, colDef } = params;
    const filtered = changes.filter(c => c.srNo === data.srNo && c.field === colDef.field);
    if(filtered.length > 0){
      return {color: '#fff', background:'rgb(33, 150, 243)'}
    }
    else return null
  }

  const _getTooltipValue = params => {
    const { data, colDef } = params;
    const filtered = changes.filter(c => c.srNo === data.srNo && c.field === colDef.field);
    if(filtered.length > 0){
      const latest = filtered[filtered.length - 1];
      return latest?.oldValues
    }
    else return null
  }

  const CustomComponent = params => {
    return <div className="ag-tooltip">Old Value: {params.value}</div>
  }

  const SelectProduct = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refVendor = useRef();
    const [error, setError] = useState("");
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);

    const getVendorsList = async () => {
      OAuthService.getList(factoryVendorUrl + `?size=1000`)
        .then((list) => {
          const { factoryVendors } = list.data?._embedded;
          const activeVender = factoryVendors.filter((item) => item.active);
          setVendors(
            activeVender?.map((vendor) => ({
              label: vendor.name,
              value: vendor.id,
            }))
          );
          const vendor = factoryVendors.filter(
            (vendor) => vendor.name === data[colDef.field]
          );
          if (vendor.length > 0)
            setSelectedVendor({ value: vendor[0].id, label: vendor[0].name });
        })
        .catch((err) => setError(err.message));
    };

    const handleVendorChange = (value) => {
      if (!value) return;
      data.productId = value.value;
      props.node.setData(data);
      setSelectedVendor(value);
      // setOpenCom(false);
    };

    useEffect(() => {
      getVendorsList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedVendor?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refVendor}
          value={selectedVendor}
          onChange={handleVendorChange}
          options={vendors}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectRange = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    console.log(props);
    const refRange = useRef();
    const [range, setRange] = useState([]);
    const [selectedRange, setSelectedRange] = useState(null);
    const [allItems, setAllItems] = useState([]);
    
    if (!productId) return;
    const getRangeList = async () => {
      if (!data.product) {
        alert("Please select a product first");
        return;
      }
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );
      
      setAllItems(productList);
      setRange(
        productList.map((range) => ({
          value: range.productId,
          label: range.productName,
        }))
      );
      const range2 = ranges.filter((r) => r.productName === data[colDef.field]);
      if (range2.length > 0)
        setSelectedRange({
          value: range2[0].productId,
          label: range2[0].productName,
        });

      // OAuthService.getList(rangeUrl + `?vendorId=${data.productId}`)
      //   .then((list) => {
      //     const { ranges } = list.data?._embedded;
      //     console.log('ranges', ranges)

      //   })
      //   .catch((err) => setError(err.message));
    };

    const handleRangeChange = (value) => {
      if (!value) return;
      const selectedRange = allItems.filter(item => item.productName === value.label)[0];
      if(colDef.field === "range1")
        data.priceGroup = selectedRange?.priceGroup?.pgId;
      else if(colDef.field === "range2")
        data.priceGroup2 = selectedRange?.priceGroup?.pgId;
      console.log('value: ', data)
      setSelectedRange(value);
    };

    useEffect(() => {
      getRangeList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedRange?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refRange}
          value={selectedRange}
          onChange={handleRangeChange}
          // // isMulti
          options={range}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectCarCass = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refCarCass = useRef();
    const [carCass, setCarCass] = useState([]);
    const [selectedCarCass, setSelectedCarCass] = useState(null);

    const getCarCassList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      console.log("list", list);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Carcass" === d._class
      );
      setCarCass(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const cc = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (cc.length > 0)
        setSelectedFront({
          label: `${cc[0].productId} ${cc[0].productName}`,
          value: `${cc[0].productId} ${cc[0].productName}`,
        });
    };

    const handleCarCassChange = (value) => {
      if (!value) return;
      setSelectedCarCass(value);
    };

    useEffect(() => {
      getCarCassList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCarCass?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refCarCass}
          value={selectedCarCass}
          onChange={handleCarCassChange}
          options={carCass}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectFront = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refFront = useRef();
    const [front, setFront] = useState([]);
    const [selectedFront, setSelectedFront] = useState(null);

    const getFrontList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );

      console.log("productList", productList);

      setFront(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const SELECTED_FRONT = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (SELECTED_FRONT.length > 0)
        setSelectedFront({
          label: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
          value: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
        });
    };

    const handleFrontChange = (value) => {
      if (!value) return;
      setSelectedFront(value);
    };

    useEffect(() => {
      getFrontList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedFront?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refFront}
          value={selectedFront}
          onChange={handleFrontChange}
          options={front}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectHandle = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refHandle = useRef();
    const [handle, setHandle] = useState([]);
    const [selectedHandle, setSelectedHandle] = useState(null);

    const getHandleList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Handle" === d._class
      );

      setHandle(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const hh = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (hh.length > 0)
        setSelectedHandle({
          label: `${hh[0].productId} ${hh[0].productName}`,
          value: `${hh[0].productId} ${hh[0].productName}`,
        });
    };

    const handleHandleChange = (value) => {
      if (!value) return;
      setSelectedHandle(value);
    };

    useEffect(() => {
      getHandleList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedHandle?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refHandle}
          value={selectedHandle}
          onChange={handleHandleChange}
          options={handle}
          styles={customStyles()}
        />
      </div>
    );
  });

  useEffect(() => {
    setColumnDefs([
      {
        headerName: "Sno.",
        valueGetter: "node.rowIndex + 1",
        maxWidth: 100,
      },
      { field: "layoutName", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue},
      {field: "product", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectProduct, },
      { field: "range1", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectRange, },
      { field: "priceGroup", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle },
      { field: "front1", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectFront, },
      { field: "carcass", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectCarCass, },
      { field: "range2", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectRange, },
      { field: "priceGroup2", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle },
      { field: "front2", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectFront, },
      { field: "carcass2", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectCarCass, },
      { field: "scheme", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle,  tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "handleConcept", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "handle1", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectHandle, },
      { field: "handle2", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, cellEditorPopup: true, cellEditor: "agRichSelectCellEditor", cellEditor: SelectHandle, },
      { field: "drawerAccFinish", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "drawerType", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "antiStpMat", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "lightings", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "sinkAccsseories", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "workTops", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      { field: "plinths", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle, tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue },
      {
        headerName: "Download",
        cellRenderer: (data) => <Download data={data} />,
        maxWidth: 150,
        minWidth: 150,
        editable: false,
      },
      { field: "remarks", enableRowGroup: true, minWidth: 200, cellStyle: _cellStyle,  tooltipComponent: CustomComponent, tooltipValueGetter: _getTooltipValue},
    ]);
  }, [rowData, changes])

  const onGridReady = useCallback((params) => {
    // loadDate();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRequestClose = () => {
    setOpenRequest(false)
  }

  const handleNotificationClose = () => {
    setNotificationContent("");
  };

  const handleSubmitForReview = async () => {
    const tempData = {
      ...data,
      isDsLifeCyclePassForNextState: data?.dsLifeCycle === "SPACE_PLANNING",
      isDsStatusPassForNextState: false,
    };
    await OAuthService.putData(`${url}/${id}`, tempData).then((resp) => {
      setCurrentStatus(resp.data?.dsLifeCycle);
      // setNotificationOpen(true)
      setNotificationContent(
        "Ticket has been submitted for review. Please wait until changes are approved."
      );
      // alert('');
    });
  };

  const handleMaster = () => {
    setOpen(true);
  };


  const removePdf = () => {
    hiddenPdfFile.current.value = null;
    setPDF(null);
  };
  const removePresentation = () => {
    hiddenPresentationFile.current.value = null;
    setPresentation(null);
  };
  const onPDFChange = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const payload = {
      prvFile: fileUploaded,
    };
    OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&category=SHR&updatedBy=ramde`,
      payload
    );
    setBtnDisable(data.spacePlans.length === 0 || !data.submissionDate)
    toast.success("Upload Successfully");
    setPDF(fileUploaded);
    const formData = new FormData();
    formData.append("File", pdf);
  };

  const onPresentationChange = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const payload = {
      presentationFile: fileUploaded,
    };
    OAuthService.addFiles(
      `${uploadMultipleFiles}?dsTaskId=${id}&category=SHR&updatedBy=ramde`,
      payload
    );
    setBtnDisable(data.spacePlans.length === 0 || !data.submissionDate)
    toast.success("Upload Successfully");
    setPresentation(fileUploaded);
    const formData = new FormData();
    formData.append("File", presentation);
  };

  const handleRequestSpacePlanning = () => {
    setOpenRequest(true)
  };

  const handleRequestPlaning = async (value) => {
    const payload = {
      ...data,
      isDsLifeCyclePassForNextState: false,
      isDsStatusPassForNextState: false,
      submissionDate: new Date(value).toISOString(),
    }
    try {
      await OAuthService.putData(`${url}/${id}`, payload)
      .then(resp => {
        setOpenRequest(false);
        setData(payload);
      })
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  }

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Space Planning"
            pageName="Space Planning"
            showPaginationDropdown={showPaginationDropdown}
            handleSubmitForReview={handleSubmitForReview}
            handleBack={handleBack}
            requestCategory={data?.designStudioCategory}
            status={currentStatus}
            successMsg={successMsg}
            snackState={snackState}
            btnDisable={btnDisable}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
              <Progress currentStep={3} category={data?.designStudioCategory} />
              <Box sx={{ my: 3 }}>
                <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between">
                  <Typography variant="subtitle1">Space planning</Typography>
                  {data?.submissionDate && <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end">
                    <Button
                      disabled={currentStatus === "SPACE_PLANNING_REVIEW"}
                      variant="contained"
                      color="warning"
                      size="large"
                      onClick={handleMaster} //currentStatus === "SPACE_PLANNING_REVIEW" ?  handleMaster : () => {}
                    >
                      Add item from Master
                    </Button>
                  </div>}
                </div>
                {!data?.submissionDate && <Button
                    // disabled={currentStatus === "SPACE_PLANNING_REVIEW"}
                    variant="contained"
                    color="warning"
                    size="large"
                    className="mt-12"
                    onClick={handleRequestSpacePlanning} //currentStatus === "SPACE_PLANNING_REVIEW" ?  handleMaster : () => {}
                  >
                    Request Space Planning
                </Button>}
                {data?.submissionDate && <><div className="my-16" style={{ height: "400px" }}>
                  <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    default
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    hideCheckbox={true}
                    //onCellValueChanged={onRowValueChanged}
                  />
                </div>
                <Typography variant="subtitle1" className="mb-16">
                  Upload DWG and Presentation
                </Typography>
                <Box className="flex">
                  <div>
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={
                        pdf || currentStatus === "SPACE_PLANNING_REVIEW" || data?.spacePlans?.length === 0
                      }
                    >
                      Layout in PDF
                      <input
                        type="file"
                        className="file"
                        ref={hiddenPdfFile}
                        onChange={
                          currentStatus === "SPACE_PLANNING_REVIEW"
                            ? () => {}
                            : onPDFChange
                        }
                        disabled={
                          pdf || currentStatus === "SPACE_PLANNING_REVIEW" || data?.spacePlans?.length === 0
                        }
                      />
                    </ColorButton>
                    {pdf && (
                      <Box className="mt-16">
                        <Chip label={pdf.name} onDelete={removePdf} />
                      </Box>
                    )}
                  </div>
                  <Box className="text-center mx-16 pt-10">
                    <span className="or">or</span>
                  </Box>
                  <div>
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={
                        presentation ||
                        currentStatus === "SPACE_PLANNING_REVIEW" ||
                        data?.spacePlans?.length === 0
                      }
                    >
                      Presentation in PDF
                      <input
                        type="file"
                        className="file"
                        ref={hiddenPresentationFile}
                        onChange={
                          currentStatus === "SPACE_PLANNING_REVIEW"
                            ? () => {}
                            : onPresentationChange
                        }
                        disabled={
                          presentation ||
                          currentStatus === "SPACE_PLANNING_REVIEW" ||
                          data?.spacePlans?.length === 0
                        }
                      />
                    </ColorButton>
                    {presentation && (
                      <Box className="mt-16">
                        <Chip
                          label={presentation.name}
                          onDelete={removePresentation}
                        />
                      </Box>
                    )}
                  </div>
                </Box></>}

                {data?.comments?.additionalProp1 && (
                  <>
                    <Box className="mt-16 p-8">
                      <Typography variant="subtitle1">Comment</Typography>
                      <Divider sx={{ my: 2 }} />
                      <Timeline
                        sx={{
                          [`& .${timelineItemClasses.root}:before`]: {
                            flex: 0,
                            padding: 0,
                          },
                        }}
                      >
                        {data?.comments?.additionalProp1?.map((comment) => (
                          <TimelineItem>
                            <TimelineSeparator>
                              <TimelineDot />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <div>
                                <strong>{comment.lastModifyBy}</strong> assigned
                                you for request change
                              </div>
                              <div class="flex flex-col sm:flex-row sm:items-center mt-8 sm:mt-4 sm:space-x-8 text-md leading-5">
                                <Typography variant="body1" className="text-13">
                                  {comment.lastModifiedDate}
                                </Typography>
                              </div>
                              <Box className="mt-16 py-16 px-20 rounded-lg border">
                                {comment.comment}
                              </Box>
                            </TimelineContent>
                          </TimelineItem>
                        ))}
                      </Timeline>
                    </Box>
                  </>
                )}
              </Box>
              {data?.submissionDate && <div className="pt-16 mt-10">
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  disabled={currentStatus === "SPACE_PLANNING_REVIEW" || btnDisable}
                  onClick={
                    currentStatus === "SPACE_PLANNING_REVIEW"
                      ? () => {}
                      : handleSubmitForReview
                  }
                >
                  Submit for Review
                </Button>
              </div>}
            </div>
          </>
        }
        innerScroll
      />
      <MasterDialog
        open={open}
        handleClose={handleClose}
        id={id}
        data={data}
        spacePlaningDate={loadDate}
      />
      <Notification
        open={notificationContent !== ""}
        onClose={handleNotificationClose}
        content={notificationContent}
      />
      <SpacePlaningRequest open={openRequest} handleClose={handleRequestClose} handleRequestPlaning={handleRequestPlaning} />
    </>
  );
}
